var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{class:_vm.classes,attrs:{"icon":_vm.icon,"color":_vm.color},on:{"click":function($event){return _vm.editSchool()}}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }